<template>
  <div class="col-lg-12">
    <div class="row">
      <div class="col-lg-12 d-flex">
        <button
          class="btn btn-primary full radius-0"
          v-show="!showForm"
          @click="showForm = true"
        >
          ADICIONAR OPÇÃO
        </button>
        <div class="input-group" v-show="showForm">
          <input
            type="text"
            class="form-control"
            v-model="optionTitle"
            @keyup.enter="addOption"
            placeholder="Opção"
          />
          <div class="input-group-append">
            <button
              class="btn btn-success"
              @click="addOption"
              title="Adicionar Opção"
            >
              <font-awesome-icon icon="check" />
            </button>
            <button
              class="btn btn-danger"
              @click="showForm = false"
              title="Cancelar"
            >
              <font-awesome-icon icon="times" />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-lg-12 text-left">
        <input
          type="checkbox"
          :id="`canMarkMoreThanOne-${index}`"
          @change="updateOptions"
          v-model="choices.canMarkMoreThanOne"
        />
        <label :for="`canMarkMoreThanOne-${index}`"
          >Candidato poderá marcar mais de uma opção?</label
        >
      </div>
    </div>
    <div
      v-if="choices.canMarkMoreThanOne"
      class="row mt-1"
    >
      <div class="col-lg-12 text-left">
         <label>
          Limite de escolhas:
        </label>
        <input
          type="number"
          min="1"
          :max="choices.optionsCount"
          @change="updateOptions"
          v-model="choices.choiceLimit"
        />
      </div>
      <div class="col-lg-12 text-left">
         <label>
          Mínimo de escolhas:
        </label>
        <input
          type="number"
          min="0"
          :max="choices.optionsCount"
          @change="updateOptions"
          v-model="choices.choicesMin"
        />
      </div>
    </div>
    <div class="row mt-2">
      <div
        class="col-lg-12"
        v-for="(option, index) in choices.options"
        :key="index"
        :class="{ 'mt-2': index > 0 }"
      >
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="option.title"
            @input="updateOptions"
          />
          <div class="input-group-append">
            <div class="input-group-text">
              <input
                type="checkbox"
                :id="`rightAnswer-${option.title}`"
                v-model="option.rightAnswer"
                @change="updateOptions"
              />
              <label :for="`rightAnswer-${option.title}`" class="f14 ml-1 mb-0"
                >Opção Correta</label
              >
            </div>
            <div class="input-group-text">
              <input
                type="checkbox"
                :id="`subanswer-${option.title}`"
                v-model="option.hasSubanswer"
              />
              <label :for="`subanswer-${option.title}`" class="f14 ml-1 mb-0"
                >Tem subopção?</label
              >
            </div>
            <div class="input-group-text">
              <input
                type="checkbox"
                :id="`specify-${option.title}`"
                v-model="option.specify"
                @change="updateOptions"
              />
              <label :for="`specify-${option.title}`" class="f14 ml-1 mb-0"
                >Especificar?</label
              >
            </div>
            <button
              class="btn btn-danger radius-0"
              @click="removeOption(index)"
              title="Deletar opção"
            >
              <font-awesome-icon icon="trash" />
            </button>
          </div>
        </div>
        <input
          v-if="option.hasSubanswer"
          type="text"
          class="form-control mt-2"
          v-model="option.subanswerLabel"
          placeholder="Título da pergunta"
          @blur="updateOptions"
        />
        <input
          v-if="option.hasSubanswer"
          type="text"
          class="form-control mt-2"
          v-model="option.subanswer"
          placeholder="Subopções"
          @blur="updateOptions(index)"
        />
        <span
          v-if="option.hasSubanswer"
          class="f12"
        >
          Separe as opções com ponto e vírgula. Ex.: Opção 1; Opção 2; Opção 3
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "index"],
  data: () => ({
    optionTitle: "",
    showForm: false,
    choices: {
      canMarkMoreThanOne: false,
      options: [],
      optionsCount: 0,
      rightAnswers: 0,
      choiceLimit: null,
      choicesMin: null,
    },
  }),
  mounted() {
    if (this.value && Object.keys(this.value).length > 0)
      this.choices = this.value;
  },
  computed: {
    rightAnswersTitles() {
      return this.choices.options
        .filter((option) => option.rightAnswer)
        .map((option) => option.title);
    },
  },
  methods: {
    addOption() {
      if (this.optionTitle.length < 1) return;
      this.choices.options.push({
        title: this.optionTitle.trim(),
        rightAnswer: false,
        specify: false,
      });
      this.optionTitle = "";
      this.showForm = false;
      this.updateOptions();
    },
    removeOption(index) {
      this.choices.options.splice(index, 1);
      this.updateOptions();
    },
    updateOptions() {
      this.choices.optionsCount = this.choices.options.length;
      this.choices.rightAnswers = this.rightAnswersTitles;
      this.$emit("input", this.choices);
      eventBus.$emit("updateQuestions", []);
    },
  },
};
</script>